<template>
  <div class="section">
    <div class="basic-info-container">
      <div class="group-name">{{ groupName }}</div>
      <div class="goods-cnt">{{ goodsCnt ? goodsCnt : '' }}</div>
    </div>
    <div class="remark">
      <span class="remark-title"> Note:</span>
      <span
        class="remark-content"
        style="
          white-space: pre-line;
          overflow: hidden;
          text-overflow: ellipsis;
          display: box;
          -webkit-line-clamp: 3;
"
      >
        {{ groupNote }}
      </span>
    </div>
    <div class="cnt-list">
      <div class="row" v-for="rowIndex in rowCnt" :key="'row-' + rowIndex">
        <div
          class="col"
          v-for="colIndex in colCnt"
          :key="'row-' + rowIndex + '-col-' + colIndex"
        >
          <span class="index">{{ (rowIndex - 1) * colCnt + colIndex }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnloadingInstructionSection',
  props: {
    groupName: {
      type: String,
      required: true
    },
    goodsCnt: {
      type: Number,
      required: true
    },
    groupNote: {
      type: String,
      required: true
    },
    rowCnt: {
      type: Number,
      default: 5
    },
    colCnt: {
      type: Number,
      default: 6
    }
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';
$form-content-padding: 10px;

.section {
  border: solid;
  width: 100%;
  height: 100%;

  @extend .f-c;

  .basic-info-container {
    font-size: 24px;
    font-weight: bold;

    @extend .f-r-hsb;
    // min-height: 34.5px;
    height: 36px;
    flex-grow: 1;

    .group-name {
      border-right: solid;
      border-bottom: solid;
      width: calc(80% + 1px);
      padding-left: $form-content-padding;
      box-sizing: border-box;
      word-break: break-all;
      display: table-cell;

      &:last-child {
        border: none;
      }
    }

    .goods-cnt {
      width: calc(20% - 1px);
      border-bottom: solid;
      padding-left: $form-content-padding;
      box-sizing: border-box;
    }
  }

  .remark {
    @extend .f-c;

    padding-left: $form-content-padding;

    // .remark-title {
    //   padding-left: $form-content-padding;
    // }

    .remark-content {
      min-height: 70px;
    }
  }

  .cnt-list {
    .row {
      @extend .f-r;

      justify-content: space-evenly;

      .col {
        height: 55px;
        width: 20%;
        border-top: solid;
        border-right: solid;
      }

      .col:last-child {
        border-right: none;
      }

      .index {
        float: right;
        color: grey;
      }
    }
  }
}
</style>
